import { SvgIcon, SvgIconProps } from './SvgIcon';

export const DarkModeIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.32711 4.68597C8.50284 4.92075 8.52562 5.23642 8.3854 5.494C7.9804 6.23797 7.75 7.09095 7.75 7.99998C7.75 10.8995 10.1005 13.25 13 13.25C13.3833 13.25 13.7562 13.209 14.1149 13.1315C14.4016 13.0696 14.698 13.1804 14.8737 13.4152C15.0495 13.6499 15.0723 13.9656 14.932 14.2232C13.7892 16.3226 11.5619 17.75 9 17.75C5.27208 17.75 2.25 14.7279 2.25 11C2.25 7.76272 4.52822 5.05927 7.56826 4.40233C7.85491 4.34038 8.15137 4.4512 8.32711 4.68597ZM6.43684 6.41693C4.8335 7.31566 3.75 9.03184 3.75 11C3.75 13.8995 6.10051 16.25 9 16.25C10.4338 16.25 11.7339 15.6754 12.6819 14.7426C9.10169 14.5765 6.25 11.6213 6.25 7.99998C6.25 7.45518 6.31468 6.925 6.43684 6.41693Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
